import inventory from "../../../Assets/Img/inventory.webp";
import handgirl from "../../../Assets/Img/handgirl.webp";
import hand from "../../../Assets/Img/hand.webp";
import happygirl from "../../../Assets/Img/hapyGirl.png";
import laptopgirl from "../../../Assets/Img/laptopgirl.webp";
import location from "../../../Assets/Img/location.webp";
import Breadcrumbs from "../../../subComponent/Breadcrumbs";
import BannerLinks from "../../../subComponent/BannerLinks";
import ContactUsForm from "../../../subComponent/ContactUsForm";
import phone from '../../../Assets/Img/phone.png'
import pinLocation from '../../../Assets/Img/pin-location.png'
import email from '../../../Assets/Img/email.png'
import whatsppp from '../../../Assets/Img/whatsppp.png'
import NavBar from "../../../subComponent/NavBar";


const ContactUS = () => {
  return (
    <>

      <div className="background-setting inventory-banner-backkground contactus-backdrop">
        <div className="inventory-backdrop" >
        <NavBar />
          <div className="container">
            <div className="contact-header">
              <p className="contact-heading futura text-white-50 fs_84  m-0 pb-3 pb-md-5 ">Contact</p>
              <p className="inventory-paragraph  text-white poppins  fs_32 fw-500 pb-3 pb-md-5 m-0  ">Get In Touch</p>
              <Breadcrumbs pages={['Home', 'Contact']} />
            </div>

            <div className="contact-us-color Rounded-6">
              <div className="container p-3 p-md-5">
                <div className="contact-us-image Rounded-6 m-3 mx-md-5">
                  <img src={handgirl} width="100%" alt="Your image" />
                </div>
                <div className="contact-us_hand">
                  <img src={hand} width="100" alt="Your image my-5" />
                </div>
                <p className="text-black fs_20 text-center ls_3">We Build Customized ERP Solutions That Can Help
                  Increase ProductivityReduce Cost Or Both
                  Empowering Digital Transformation</p>
                <div className='line2 mt-5 bg-black w-100'></div>
                <div className="text-center">
                  <p class="underline-with-circle-and-dot mt-3 mt-md-5 fs_22 poppins ls_2 text-black  pt-3">General Enquiry</p>
                </div>
                <div className="contact-us-image m-3 mx-md-5">
                  <img src={laptopgirl} width="100%" alt="Your image my-5" />
                </div>
                <div className="row m-3 mx-md-5 ">
                  <div className="col-12 p-3" >
                    <div className="phone-section_wrapper py-3 h-100">
                      <div className="phone-section d-flex gap-2 gap-md-4   align-items-center">
                        <div className="phone-icon">
                          <img src={phone} width="30px" alt="Your image my-5" />
                        </div>
                        <div className="phone-number text-white fs_20 poppins">
                          Phone
                        </div>
                      </div>
                      <p className="text-white text-center ls_2 futura">
                        +60 17-656 9760 /+603-7622 9772
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 p-3" >
                    <div className="phone-section_wrapper py-3 h-100">
                      <div className="phone-section d-flex gap-2 gap-md-4 align-items-center">
                        <div className="phone-icon">
                          <img src={whatsppp} width="30px" alt="Your image my-5" />
                        </div>
                        <div className="phone-number text-white fs_20 poppins">
                          WhatsApp

                        </div>

                      </div>
                      <p className="text-white text-center text-centerfutura pt-2">
                        +60 17-656 9760
                      </p>

                    </div>
                  </div>
                  <div className="col-md-6 p-3" >
                    <div className="phone-section_wrapper py-3 h-100">
                      <div className="phone-section d-flex gap-2  align-items-center ">
                        <div className="phone-icon">
                          <img src={email} width="30px" alt="Your image my-5" />
                        </div>
                        <div className="phone-number text-white fs_20 poppins">
                          Email
                        </div>
                      </div>
                      <p className="text-white text-center text-centerfutura pt-2">
                        info@smartb.co
                      </p>
                    </div>
                  </div>
                  <div className="col-12 p-3" >
                    <div className="phone-section_wrapper py-3 h-100">
                      <div className="phone-section d-flex gap-2 gap-md-4  align-items-center">
                        <div className="phone-icon">
                          <img src={pinLocation} width="30px" alt="Your image my-5" />
                        </div>
                        <div className="phone-number text-white fs_20 poppins">
                          Address
                        </div>
                      </div>
                      <div className="adress-section">
                        <p className="text-white   ls_2 p-0 m-0 futura">
                          Unit A211, 2nd Floor, Lift Lobby 3,</p>
                        <p className="text-white ls_2  p-0 m-0 futura">
                          lock A, Damansara Intan E-Business Park,</p>
                        <p className="text-white  ls_2 p-0 m-0  futura">
                          1, Jln SS 20/27, 47400
                        </p>
                        <p className="text-white ls_2  p-0 m-0 futura">
                          Petaling Jaya, Selangor, Malaysia.</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="row form-section py-5 mt-5 ">
                  <div className="col-12 col-md-5 form-image">
                    <img src={happygirl} width="100%" alt="Your image my-5" />
                  </div>
                  <div className="col-12 col-md-7">
                    <div className="gradient-line contact-us_gradient mb-4"></div>
                    <p className="contact-form_heading ls_3 poppins text-black ">
                      Have a little something, something you wanna talk to us about? Well give us a ring, send us an email, or fill out that nifty form below.
                    </p>
                    <p className="contact-form_text fs_16 ls_2 futura">
                      Fill out this form and we’ll be in touch with you as soon as possible*
                    </p>
                    <ContactUsForm />
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-us-color Rounded-6 my-5 ">
              <div className="container">
                <div className="text-center">
                  <p class="underline-with-circle-and-dot mt-5 fs_22 poppins ls_2 text-black  pt-0 pt-md-5">Feature</p>
                </div>
                <div className="contact-us-image  mx-0 mx-md-2 px-2 px-md-5 pt-2 pt-md-3 ">
                  <img src={handgirl} width="100%" alt="Your image my-3 my-md-5" />
                </div>
                <div className="text-center">

                  <p class="underline-with-circle-and-dot mt-3 mt-md-5 fs_22 poppins ls_2 text-black  pt-0 pt-md-5">Parking / Directions</p>
                </div>
                <div className="contact-us-image  mx-0 mx-md-2 px-2 px-md-5 pt-2 pt-md-3 ">
                  <img src={location} width="100%" alt="Your image my-5" />
                </div>
                <div className="mx-2 px-3 px-md-5">
                  <p className=" ls_2 futura">Best park your car in 3 Damansara (previously known as Tropicana City Mall) on Level B2 near pillar G34. From the exit, walk across to road and go to the left side of the building (the side facing Sprint highway). You will walk pass Prudential office and Banana restaurant (on your right). Walk along that row of shops until staircase No 3.</p>
                  <p className=" ls_2 futura">Alternatively, for those arriving after 6pm, you may park on ground floor at any convenient spots. Reserved parking does NOT apply after 6pm.</p>
                  <p className=" ls_2 futura pb-5">If you're travelling by public transport, best take the LRT to Taman Tun Dr Ismail (TTDI) MRT station. Walking is about 10 mins or you can take a taxi from there. </p>
                </div>
              </div>
            </div>
            <div>
              <div className="Home_Background background-setting py-5" >
                <p className="futura fs_8 text-white m-0 text-center">Home</p>
              </div>
              <BannerLinks />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default ContactUS

